<template>
    <div class="mask">
        <div class="container">
            <div class="title">请选择您的身份类型后，创建小程序</div>
            <div class="list">
                <template v-for="item in initData">
                    <div
                        :key="item.id"
                        @click="onSelect(item.versionId)"
                        class="list-item"
                        :class="{ actived: item.versionId === selectVersionId }"
                    >
                        <div class="list-item__header">
                            <div class="list-item__title">
                                {{ item.versionName }}
                            </div>
                            <div class="list-item__sub">
                                {{ item.versionDesc }}
                            </div>
                        </div>
                        <div v-html="item.functionDesc"></div>
                    </div>
                </template>
            </div>
            <div class="footer">
                <div class="btn" @click="onStep">确认版本类型</div>
            </div>
        </div>
    </div>
</template>
<script>
import { ApiUpdateVersion } from '@/common/api';
export default {
    name: 'Version-Select',
    props: {
        initData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            selectVersionId: undefined
        };
    },
    methods: {
        // 选择
        onSelect(versionId) {
            this.selectVersionId = versionId;
        },
        // 确定
        onStep() {
            if (!this.selectVersionId) {
                this.$message.error('请选择版本类型');
                return;
            }
            this.updateVersion();
        },
        // 提交
        updateVersion() {
            ApiUpdateVersion(this.selectVersionId).then(() => {
                // 跳转到小程序创建页面
                this.$router.replace({
                    path: '/any/merchant/shop/mini-manage'
                });
            });
        }
    }
};
</script>
<style lang="scss">
.sup-remark {
    margin-top: 10px;
    .link {
        text-decoration: none;
        span {
            line-height: 14px;
            color: #0091ff;
            font-size: 14px;
        }
        img {
            width: 12px;
            height: 12px;
            position: relative;
            top: 1px;
        }
    }
}
</style>
<style lang="scss" scoped>
.mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 11;
}
.container {
    background: #ffffff;
    border-radius: 8px;
    width: 900px;
    padding: 50px 0 65px;
    .title {
        margin: 0 auto 40px;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 28px;
    }
    .list {
        display: flex;
        height: 400px;
        overflow-y: scroll;
        margin: 0 auto;
        flex-wrap: wrap;
        padding: 0 15px;
    }
    .list-item {
        &:nth-child(odd) {
            margin-right: 20px;
        }
        margin-bottom: 20px;
        cursor: pointer;
        width: 375px;
        height: 278px;
        padding: 0 15px;
        background: #ffffff;
        box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        border: 1px solid #efefef;
        &__header {
            padding: 40px 17px 20px 20px;
            border-bottom: 1px dashed #efefef;
            margin: 0 -20px 20px;
        }
        &__title {
            font-size: 22px;
            font-weight: 500;
            color: #333333;
            line-height: 22px;
        }
        &__sub {
            margin-top: 12px;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            line-height: 14px;
        }
    }
    .actived {
        border: 1px solid #ff3037;
        background: #fff5f5;
        box-shadow: 0px 5px 10px 0px rgba(255, 0, 0, 0.1);
    }
    .footer {
        text-align: center;
        margin-top: 30px;
        .btn {
            cursor: pointer;
            margin: 0 auto;
            width: 167px;
            height: 48px;
            background: #ff3037;
            border-radius: 4px;
            line-height: 48px;
            text-align: center;
            color: #fff;
            font-size: 16px;
            font-weight: 500;
        }
    }
}
</style>
